import type { MarketingPage } from "../types/domain";

export const marketingPages: Record<string, MarketingPage> = {
  ask: {
    title: "Hỏi là có",
    summary:
      "Gửi ảnh, mã phụ tùng hoặc mô tả lỗi. Đội sourcing kiểm tra kho, nhà cung cấp và kênh marketplace trước khi báo lại.",
    primaryAction: "Gửi yêu cầu",
    secondaryAction: "Xem lịch sử",
    sections: [
      {
        title: "Quy trình sourcing",
        body: "Mỗi yêu cầu có mã theo dõi, trạng thái, ghi chú kỹ thuật và lựa chọn thay thế khi hàng chính hãng chưa có.",
        points: ["Tiếp nhận ảnh/mã phụ tùng", "Kiểm tra tương thích", "Báo giá và thời gian về hàng"]
      },
      {
        title: "Cho người dùng và thợ",
        body: "Luồng được thiết kế để thợ sửa, garage và khách lẻ đều gửi thông tin nhanh trên di động.",
        points: ["Mobile-first", "Không cần biết tên SKU", "Có ghi chú kỹ thuật"]
      }
    ]
  },
  b2b: {
    title: "B2B / Đại lý",
    summary:
      "Chính sách giá, công nợ và hạn mức cho thợ sửa, garage, đội xe và đại lý phụ tùng.",
    primaryAction: "Đăng ký B2B",
    secondaryAction: "Liên hệ kinh doanh",
    sections: [
      {
        title: "Quyền lợi",
        body: "Tài khoản B2B có cấp giá riêng, lịch sử mua hàng, yêu cầu sourcing và đơn đặt hàng nhanh.",
        points: ["Cấp giá theo nhóm", "Hạn mức công nợ", "Đơn nhanh từ file SKU"]
      },
      {
        title: "Kiểm soát vận hành",
        body: "Hệ thống quản trị theo dõi báo giá, đơn hàng, tồn kho và đối soát để hạn chế lệch dữ liệu.",
        points: ["Theo dõi SLA", "Đối soát COD", "Audit log"]
      }
    ]
  },
  brands: {
    title: "Thương hiệu",
    summary:
      "Danh bạ hãng xe, thương hiệu phụ tùng và nhóm hàng để khách tìm đúng mã nhanh hơn.",
    primaryAction: "Tìm thương hiệu",
    sections: [
      {
        title: "Hãng phổ biến",
        body: "VinFast, Honda, Yamaha, Yadea, Dat Bike, Nissin, Motul, Bando.",
        points: ["Lọc theo xe", "Lọc theo nhóm hàng", "Gợi ý sản phẩm tương thích"]
      }
    ]
  },
  blog: {
    title: "Blog kỹ thuật",
    summary:
      "Bài viết hướng dẫn chọn phụ tùng, kiểm tra lỗi và bảo dưỡng xe điện, xe máy, ô tô điện.",
    primaryAction: "Đọc bài mới",
    sections: [
      {
        title: "Chủ đề",
        body: "Hướng dẫn chọn sạc, nhận biết bố thắng mòn, bảng tương thích dây curoa và checklist bảo dưỡng.",
        points: ["Tư vấn kỹ thuật", "So sánh sản phẩm", "Kinh nghiệm thợ"]
      }
    ]
  },
  contact: {
    title: "Liên hệ",
    summary:
      "Kết nối bán hàng, kỹ thuật, B2B, nhà cung cấp và hỗ trợ đơn hàng từ một cửa.",
    primaryAction: "Gửi liên hệ",
    secondaryAction: "Tra cứu đơn",
    sections: [
      {
        title: "Kênh hỗ trợ",
        body: "Đội ngũ vận hành phản hồi theo đúng nhóm yêu cầu để tránh chuyển vòng.",
        points: ["Bán hàng", "Kỹ thuật", "B2B", "Nhà cung cấp"]
      }
    ]
  },
  faq: {
    title: "FAQ",
    summary:
      "Câu hỏi thường gặp về đặt hàng, giao hàng, đổi trả, bảo hành và yêu cầu tìm phụ tùng.",
    primaryAction: "Tìm câu hỏi",
    sections: [
      {
        title: "Câu hỏi chính",
        body: "Thông tin được chia theo nhóm để khách tự xử lý nhanh trước khi cần hỗ trợ trực tiếp.",
        points: ["Đặt hàng", "Thanh toán", "Bảo hành", "Đổi trả"]
      }
    ]
  },
  "track-order": {
    title: "Tra cứu đơn",
    summary: "Nhập mã đơn hoặc số điện thoại để xem trạng thái giao hàng, thanh toán và bảo hành.",
    primaryAction: "Tra cứu",
    sections: [
      {
        title: "Thông tin trả về",
        body: "Timeline xử lý, trạng thái vận chuyển, chi tiết đơn và kênh hỗ trợ tiếp theo.",
        points: ["Mã đơn", "Số điện thoại", "Timeline vận chuyển"]
      }
    ]
  },
  about: {
    title: "Về Siêu Thị Ưa Thích",
    summary:
      "Nền tảng commerce phụ tùng gom bán hàng, kho, mua hàng và đối soát.",
    primaryAction: "Xem danh mục",
    sections: [
      {
        title: "Định vị",
        body: "Tập trung vào phụ tùng khó tìm, thông tin tương thích rõ ràng và vận hành đa kênh có kiểm soát.",
        points: ["Commerce", "Hỏi là có", "Vận hành rõ"]
      }
    ]
  }
};

export const policyPages: Record<string, MarketingPage> = {
  "privacy-policy": {
    title: "Chính sách bảo mật",
    summary: "Nguyên tắc thu thập, sử dụng và bảo vệ dữ liệu khách hàng.",
    primaryAction: "Liên hệ hỗ trợ",
    sections: [
      {
        title: "Dữ liệu",
        body: "Chỉ thu thập thông tin cần thiết cho đặt hàng, giao hàng, bảo hành và hỗ trợ.",
        points: ["Tối thiểu dữ liệu", "Không công khai thông tin", "Quyền yêu cầu chỉnh sửa"]
      }
    ]
  },
  terms: {
    title: "Điều khoản sử dụng",
    summary: "Điều khoản đặt hàng, tài khoản, thanh toán và trách nhiệm sử dụng dịch vụ.",
    primaryAction: "Quay về trang chủ",
    sections: [
      {
        title: "Phạm vi",
        body: "Áp dụng cho khách lẻ, B2B, đại lý và các tương tác trong hệ thống.",
        points: ["Tài khoản", "Đơn hàng", "Hỗ trợ"]
      }
    ]
  },
  "shipping-policy": {
    title: "Chính sách vận chuyển",
    summary: "Quy định đóng gói, bàn giao vận chuyển, phí giao hàng và kiểm tra khi nhận.",
    primaryAction: "Tra cứu đơn",
    sections: [
      {
        title: "Giao hàng",
        body: "Đơn hàng có timeline, mã vận đơn và trạng thái xử lý rõ ràng.",
        points: ["Nội thành", "Liên tỉnh", "Đồng kiểm"]
      }
    ]
  },
  "return-policy": {
    title: "Chính sách đổi trả",
    summary: "Điều kiện đổi trả, quy trình tiếp nhận và kiểm tra tình trạng phụ tùng.",
    primaryAction: "Tạo yêu cầu",
    sections: [
      {
        title: "Điều kiện",
        body: "Sản phẩm đổi trả cần còn đủ chứng từ, tình trạng phù hợp và nằm trong thời hạn áp dụng.",
        points: ["Đúng mã", "Còn tem", "Có hóa đơn"]
      }
    ]
  },
  "warranty-policy": {
    title: "Chính sách bảo hành",
    summary: "Quy trình bảo hành sản phẩm, phụ tùng điện tử và nhóm hàng có điều kiện riêng.",
    primaryAction: "Gửi bảo hành",
    sections: [
      {
        title: "Bảo hành",
        body: "Mỗi yêu cầu có mã theo dõi và ghi nhận trạng thái xử lý.",
        points: ["Tiếp nhận", "Kiểm tra", "Hoàn tất"]
      }
    ]
  }
};
